import { debounce } from '@util'
import html from './template.html'

const template = document.createElement('template')
template.innerHTML = html

customElements.define(
    'municipality-picker-filter',
    class extends HTMLElement {
        constructor() {
            super()

            const shadow = this.attachShadow({ mode: 'open' })
            shadow.append(template.content.cloneNode(true))

            this.onSubmit = this.onSubmit.bind(this)
            this.onInputInput = debounce(this.onInputInput.bind(this), 250)
            this.onFilterChange = this.onFilterChange.bind(this)
        }

        /**
         * Returns the form element from the Shadow DOM.
         */
        get form() {
            return this.shadowRoot.querySelector('form')
        }

        /**
         * Returns the input element from the Shadow DOM.
         */
        get input() {
            return this.shadowRoot.querySelector('input')
        }

        /**
         * Returns the select element from the Shadow DOM.
         */
        get select() {
            return this.shadowRoot.querySelector('select')
        }

        /**
         * Returns the button element from the Shadow DOM.
         */
        get button() {
            return this.shadowRoot.querySelector('button')
        }

        connectedCallback() {
            this.form.addEventListener('submit', this.onSubmit)
            this.input.addEventListener('input', this.onInputInput)
            this.select.addEventListener('change', this.onFilterChange)
        }

        disconnectedCallback() {
            this.form.removeEventListener('submit', this.onSubmit)
            this.input.removeEventListener('input', this.onInputInput)
            this.select.removeEventListener('change', this.onFilterChange)
        }

        /**
         * Disable the submit event.
         * @param {Event} event
         */
        onSubmit(event) {
            event.preventDefault()
        }

        /**
         * Get the input value and send a search query.
         */
        onInputInput() {
            const query = this.input.value
            this.dispatchMunicipalitySearchEvent(query)
        }

        /**
         * Listen to changes in the form.
         * When a change happens dispatch a countychange event.
         */
        onFilterChange(event) {
            const county = event.target.value
            let value = county !== '' ? county : null
            this.dispatchCountyChangeEvent(value)
        }

        /**
         * Reset the map on button click.
         */
        onButtonClick() {
            this.dispatchCountyChangeEvent(null)
        }

        /**
         * Dispatches a municipalitysearch event with a query.
         * @param {string} value
         */
        dispatchMunicipalitySearchEvent(value) {
            this.dispatchEvent(
                new CustomEvent('municipalitysearch', {
                    bubbles: true,
                    detail: {
                        query: value,
                    },
                })
            )
        }

        /**
         * Dispatches a countychange event with a statcode.
         * @param {string} value
         */
        dispatchCountyChangeEvent(value) {
            this.dispatchEvent(
                new CustomEvent('countychange', {
                    bubbles: true,
                    detail: {
                        statcode: value,
                    },
                })
            )
        }

        /**
         * Renders the options based on the passed data.
         * @param {object[]} options An array of title and statcode objects.
         * @param {string|null} [selectedOption] Statcode string or null.
         */
        setOptions(options, selectedOption = null) {
            this.clearOptions()

            const defaultOption = new Option(
                '-Kies provincie-',
                '',
                selectedOption === null ? true : false
            )
            this.select.add(defaultOption)

            for (const { title, statcode } of options) {
                const option = new Option(
                    title,
                    statcode,
                    false,
                    selectedOption === statcode
                )
                this.select.add(option)
            }
        }

        /**
         * Remove all previous options before rendering.
         */
        clearOptions() {
            const length = this.select.options.length
            for (let i = length - 1; i >= 0; i--) {
                this.select.remove(i)
            }
        }
    }
)



// WEBPACK FOOTER //
// ./scripts/web-components/municipality-picker-filter/index.js